import React, {Component} from 'react';
import * as THREE from 'three';

const initialState = {
    faces: [],
    faceVertexUvs: [],
    vertices: []
};

export default class PlanetOcean extends Component {

    state = initialState;

    componentDidMount() {
        const {noise, point, region, radius} = this.props;
        if (noise < 0) {
            this.setGeometry(point, region, radius);
        }
    }

    componentWillReceiveProps({noise, point, region, radius}) {
        if (noise < 0) {
            if (point !== this.props.point || region !== this.props.region) {
                this.setGeometry(point, region, radius);
            } else if (radius !== this.props.radius) {
                const geometry = new THREE.Geometry(), {vertices, faces} = this.state;
                geometry.vertices = vertices.map(vertice => vertice.setLength(radius));
                geometry.faces = faces;
                this.setGeometryProps(geometry);
            }
        } else {
            this.setState(initialState);
        }
    }

    shouldComponentUpdate(props, {vertices}) {
        return vertices !== this.state.vertices;
    }

    setGeometry = (point, region, radius) => {
        const vertices = region.map(vertice => new THREE.Vector3(...vertice)),
            geometry = new THREE.Geometry(),
            getNextIndex = v => v === vertices.length - 1
                ? 0
                : v + 1;
        geometry.vertices = [
            ...vertices,
            new THREE.Vector3(...point)
        ].map(vertice => vertice.setLength(radius));
        // Compute Faces
        geometry.faces = vertices.reduce(
            (faces, vertice, v) => faces.concat([new THREE.Face3(vertices.length, v, getNextIndex(v))]),
            []
        );
        this.setGeometryProps(geometry);
    }

    setGeometryProps = (geometry) => {
        geometry.computeVertexNormals();
        geometry.computeFaceNormals();
        this.setState(
            {faces: geometry.faces, faceVertexUvs: geometry.faceVertexUvs, vertices: geometry.vertices}
        );
        geometry.dispose();
    }

    render() {
        const {vertices, faces, faceVertexUvs} = this.state;
        return <mesh>
            <geometry vertices={vertices} faces={faces} faceVertexUvs={faceVertexUvs}/>
            <materialResource resourceId="water-surface"/>
        </mesh>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/planet/ocean.js